export default __webpack_public_path__ + "static/media/home-service-logo-mid.9dfb307f.svg";